/*
 * Filename: field-rule-array.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, getSnapshot } from 'mobx-state-tree';
import { CQMasterDataStore } from '../cq-master-data.store';

let initialState: any;
export const GridObject = types.model({
    headerActionTypes: types.optional(types.array(types.frozen()), []),
    rowActionTypes: types.optional(types.array(types.frozen()), []),
    gridComponentConfigView: types.optional(types.frozen(), {}),
    selectedHeaderAction: types.optional(types.frozen(), {}),
    headerActions: types.optional(types.frozen(), {}),
    selectedAction: types.optional(types.string, ''),
    selectedRowAction: types.optional(types.frozen(), {}),
    standardActionObject: types.optional(types.frozen(), {}),
    customActionObject: types.optional(types.frozen(), {}),
    orderedHeaderActions: types.optional(types.array(types.frozen()), []),
    orderedRowAction: types.optional(types.array(types.frozen()), []),
}).actions((self: any) => ({
    afterCreate: () => {
        initialState = getSnapshot(self);
    },
    reset() {
        Object.keys(self).forEach((itemKey: string) => {
            self[itemKey] = initialState[itemKey];
        });
    },
    resetCustomAction(actionName: string) {
        self.customActionObject = initialState['customActionObject'];
    },
    updateGridField(fieldName: string, fieldValue: any,selectedTemplateName?:string) {
        self[fieldName] = fieldValue;
        if (fieldName === 'selectedHeaderAction' && selectedTemplateName) {
            self.deleteUnsavedData(fieldValue, selectedTemplateName);
        };
    },
    deleteUnsavedData(fieldValue: any, selectedTemplateName: string) {
        const outputConfig = CQMasterDataStore.OutputConfig;
        let ruleElementsObj = outputConfig.getStoreKeyData(selectedTemplateName, 'ruleElements');
        if (ruleElementsObj.hasOwnProperty('gridObject')) {
            let gridObj = { ...ruleElementsObj.gridObject };
            Object.keys(gridObj).length && Object.keys(gridObj).map((actionObjectKey: any) => {
                if (!gridObj[actionObjectKey].hasOwnProperty('isActionSaved')) {
                    delete gridObj[actionObjectKey];
                }
            });
            ruleElementsObj.gridObject = gridObj;
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(selectedTemplateName, 'ruleElements', ruleElementsObj);
        }
    },
    updateCustomAction(customObject: any) {
        const customActionObject = { ...self.customActionObject };
        customActionObject.isBulkChecked = customObject.isBulkChecked;
        customActionObject.name = customObject.name;
        customActionObject.label = customObject.label;
        customActionObject.componentName = customObject.componentName;
        self.customActionObject = customActionObject;
        const outputConfig: any = { ...CQMasterDataStore.OutputConfig };
        const headerActions: any[] = [...outputConfig['cqGridGenerator'].headerActions];
        headerActions.push(self.customActionObject);
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue('cqGridGenerator', 'headerActions', headerActions);
    },
    updateStandardAction(standardActionObject: any) {
        let actionObject = { ...self.standardActionObject }
        actionObject = { ...actionObject, ...standardActionObject }
        self.standardActionObject = actionObject;
    }

}));
